module.exports = __webpack_public_path__ + "img/kr-product-content3-img-1.60c4a4e.png";